module.exports = __webpack_public_path__ + "media/assets/icons/cancer_icon-f5283ad986e15c8d62ea6bae289ebfe9.svg";